module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAqklEQVQ4T+WTWw3CQBBFTx0gAQmVgBQcFAlIKA6QggQkVEIdQA7pJJNlF0j2k5tMso+ZO++BTgyd9rQIZuAArJuDHXADTqXDIFBhSp9H4Fool28XHeQIZB+B/eatlp1RLcAdMMq3FFRQzo3a+G4qygtlDYLA3FXyLuIctfhKkI1q538giFbZUuE9t/hjDRwYpQaHS2kSRJseaYyDyD/bnke8uQs/71j3Nj4BAsMvER8hnYUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/del.png
// module id = +Vg6
// module chunks = 1